import SuccessTaskMessage from '@/spectrum/components/SuccessTaskMessage/SuccessTaskMessage';
import { SpectrumProductModel } from '@/spectrum/entities/SpectrumProduct';

export function generateSuccessMessage(group: string, taskId: string, model: SpectrumProductModel) {
  return <SuccessTaskMessage group={group} taskId={taskId} spectrumProduct={model} />;
}
